// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__377Ky","header":"PatientQuestionnaire_header__1hPm2","info":"PatientQuestionnaire_info__21PH5"};